import script from "./YourDetailsCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./YourDetailsCompleted.vue?vue&type=script&setup=true&lang=js"

import "./YourDetailsCompleted.vue?vue&type=style&index=0&id=3499ab26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3499ab26"]])

export default __exports__